import ws from '../utils/ws';

/* Actions */

export const cellRadiationSurveyValueUpdate = values => dispatch =>
  dispatch({
    type: CREATE_CELL_RADIATION_SURVEY_VALUE_UPDATE,
    payload: values
  });

export const cellRadiationSurveyValueReset = () => dispatch =>
  dispatch({
    type: CREATE_CELL_RADIATION_SURVEY_VALUE_RESET
  });

export const setConfirmDeleteCellRadiationSurveyOpen = open => dispatch =>
  dispatch({
    type: SET_CONFIRM_DELETE_CELL_RADIATION_SURVEY_OPEN,
    payload: open
  });

export const editCellRadiationSurvey = (
  cell,
  radiationSurveyGuid
) => dispatch =>
  dispatch({
    type: EDIT_CELL_RADIATION_SURVEY,
    payload: ws.get(
      `/cells/${cell.id}/radiation_surveys/${radiationSurveyGuid}`
    )
  });

export const saveCellRadiationSurvey = (values, cell) => dispatch =>
  dispatch({
    type: SAVE_CELL_RADIATION_SURVEY,
    payload: ws.post(`/cells/${cell.id}/radiation_surveys/`, {
      ...values
    })
  });

export const deleteCellRadiationSurvey = (
  cell,
  radiationSurveyGuid
) => dispatch =>
  dispatch({
    type: DELETE_CELL_RADIATION_SURVEY,
    payload: ws.post(
      `/cells/${cell.id}/radiation_surveys/${radiationSurveyGuid}/delete`
    )
  });

export const setCreateCellRadiationSurveyOpen = open => dispatch =>
  dispatch({
    type: SET_CREATE_CELL_RADIATION_SURVEY_OPEN,
    payload: open
  });

/* Constants */

export const SET_CREATE_CELL_RADIATION_SURVEY_OPEN =
  'SET_CREATE_CELL_RADIATION_SURVEY_OPEN';

export const CREATE_CELL_RADIATION_SURVEY_VALUE_UPDATE =
  'CREATE_CELL_RADIATION_SURVEY_VALUE_UPDATE';
export const CREATE_CELL_RADIATION_SURVEY_VALUE_RESET =
  'CREATE_CELL_RADIATION_SURVEY_VALUE_RESET';

export const SET_CONFIRM_DELETE_CELL_RADIATION_SURVEY_OPEN =
  'SET_CONFIRM_DELETE_CELL_RADIATION_SURVEY_OPEN';

export const EDIT_CELL_RADIATION_SURVEY = 'EDIT_CELL_RADIATION_SURVEY';
export const EDIT_CELL_RADIATION_SURVEY_PENDING =
  'EDIT_CELL_RADIATION_SURVEY_PENDING';
export const EDIT_CELL_RADIATION_SURVEY_FULFILLED =
  'EDIT_CELL_RADIATION_SURVEY_FULFILLED';

export const SAVE_CELL_RADIATION_SURVEY = 'SAVE_CELL_RADIATION_SURVEY';
export const SAVE_CELL_RADIATION_SURVEY_FULFILLED =
  'SAVE_CELL_RADIATION_SURVEY_FULFILLED';

export const DELETE_CELL_RADIATION_SURVEY = 'DELETE_CELL_RADIATION_SURVEY';
export const DELETE_CELL_RADIATION_SURVEY_FULFILLED =
  'DELETE_CELL_RADIATION_SURVEY_FULFILLED';
